// profile-edit-routes.js


import React from 'react';
import { renderForMobileContext } from 'utils/app-context';
import ProfileDetails from "./profile-details";
import ProfileNotifications from "./profile-notifications";
import ProfilePhoto from './profile-photo';
import ProfileDocuments from './profile-documents';
import ProfilePassword from './profile-password';
import ProfileAppPasscode from './profile-app-passcode';
import { ReactComponent as EditIcon } from 'assets/images/edit.svg';
import { ReactComponent as PhotoIcon } from 'assets/images/photo.svg';
import { ReactComponent as DocumentsIcon } from 'assets/images/documents.svg';


export default function(user, currentUser) {
  const routeDefs = {
    details: {
      key: 'details',
      iconName: 'edit',
      label: 'Details',
      path: '/details',
      component: ProfileDetails,
      isDefaultPage: true,
      backgroundImage: <EditIcon />
    },
    notifications: {
      key: 'notifications',
      iconName: 'notifications-edit',
      label: 'Notifications',
      path: '/notifications',
      component: ProfileNotifications,
      backgroundImage: <EditIcon />
    },
    photo: {
      key: 'photo',
      iconName: 'photo',
      label: 'Department Logo',
      path: '/photo',
      component: ProfilePhoto,
      backgroundImage: <PhotoIcon />
    },
    documents: {
      key: 'documents',
      iconName: 'user-guide',
      label: 'Uploaded Documents',
      path: '/docs',
      component: ProfileDocuments,
      backgroundImage: <DocumentsIcon />
    },
    password: {
      key: 'change-password',
      iconName: 'password',
      label: 'Change Password',
      path: '/password',
      component: ProfilePassword
    },
    passcode: {
      key: 'mobile-passcode',
      iconName: 'passcode',
      label: 'Quick Access Passcode',
      path: '/passcode',
      component: ProfileAppPasscode
    }
  };

  const routes = [];
  routes.push(routeDefs.details);
  if( user.id === currentUser.id && !user.role.isSupervisor )
    routes.push(routeDefs.notifications);
  routes.push(routeDefs.photo);
  routes.push(routeDefs.documents);

  if (!user || !currentUser) {
    return [];
  }

  if (user.id === currentUser.id) {
    routes.push(routeDefs.password);

    if (renderForMobileContext()) {
      routes.push(routeDefs.passcode);
    }
  }

  return routes;
}